import { render, staticRenderFns } from "./Cuenta.vue?vue&type=template&id=5f6f8646&scoped=true&"
import script from "./Cuenta.vue?vue&type=script&lang=js&"
export * from "./Cuenta.vue?vue&type=script&lang=js&"
import style0 from "./Cuenta.vue?vue&type=style&index=0&id=5f6f8646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f8646",
  null
  
)

export default component.exports